import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { ROUTES } from "../../../utilities/constant";
import { API_VERIFY_EMAIL, API_RESEND_EMAIL_VERIFICATION } from "../../../service/url";
import { postApiNoAuthCall } from "../../../service/postApiCall";
import "../../../../src/assets/custom/css/SignIn.css";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const [username, setUsername] = useState("");
  const [otp, setOtp] = useState("");
  const [busy, setBusy] = useState(false);
  const [resendBusy, setResendBusy] = useState(false);

  useEffect(() => {
    const fromState = location.state?.username;
    const fromQuery = searchParams.get("username");
    const initial = (fromState || fromQuery || "").trim();
    if (initial) {
      setUsername(initial);
    }
  }, [location.state, searchParams]);

  const submitVerify = async (e) => {
    e.preventDefault();
    if (!username.trim()) {
      toast.error("Username is required");
      return;
    }
    if (!otp.trim() || otp.trim().length !== 6) {
      toast.error("Please enter the 6-digit code from your email");
      return;
    }
    setBusy(true);
    try {
      const resp = await postApiNoAuthCall(API_VERIFY_EMAIL, {
        username: username.trim(),
        otp: otp.trim(),
      });
      if (resp?.success) {
        toast.success(resp.message || "Email verified. You can sign in now.");
        setTimeout(() => navigate(`/${ROUTES.LOGIN}`), 1200);
      }
    } catch (err) {
      toast.error(typeof err === "string" ? err : "Verification failed");
    } finally {
      setBusy(false);
    }
  };

  const resend = async () => {
    if (!username.trim()) {
      toast.error("Enter your username first");
      return;
    }
    setResendBusy(true);
    try {
      const resp = await postApiNoAuthCall(API_RESEND_EMAIL_VERIFICATION, {
        username: username.trim(),
      });
      if (resp?.success) {
        toast.success(resp.message || "A new code has been sent to your email");
        if (resp.data?.email) {
          toast.info(`Sent to ${resp.data.email}`);
        }
      }
    } catch (err) {
      toast.error(typeof err === "string" ? err : "Could not resend code");
    } finally {
      setResendBusy(false);
    }
  };

  return (
    <div className="auth-container signin-container">
      <div className="right-panel" style={{ margin: "0 auto", maxWidth: 480, padding: "2rem" }}>
        <div className="formCard">
          <h2 className="title">Verify your email</h2>
          <p className="subtitle">
            Enter the 6-digit code sent to your email. New accounts must verify before signing in.
          </p>

          <div className="form-group">
            <label className="label" htmlFor="ve-username">
              Username
            </label>
            <input
              id="ve-username"
              className="input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Your username"
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label className="label" htmlFor="ve-otp">
              Verification code
            </label>
            <input
              id="ve-otp"
              className="input"
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
              placeholder="6-digit code"
              inputMode="numeric"
              maxLength={6}
            />
          </div>

          <button
            type="button"
            className="button"
            disabled={busy}
            onClick={submitVerify}
          >
            {busy ? <div className="spinner" /> : "Verify email"}
          </button>

          <button
            type="button"
            className="button"
            style={{ marginTop: 12, background: "#6c757d" }}
            disabled={resendBusy}
            onClick={resend}
          >
            {resendBusy ? "Sending…" : "Resend code"}
          </button>

          <p style={{ marginTop: "1.5rem", textAlign: "center" }}>
            <Link to={`/${ROUTES.LOGIN}`}>Back to sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
